import { Scrollbar, Select } from '@repo/go-ui';
import Markdown from 'markdown-to-jsx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { ImageBroadcastingWidgetState } from '../../model/ImageBroadcastingWidgetState';

import styles from './CommentsPane.module.scss';
import { markdownComponents } from './MarkdownComponents';

type Props = {
  widgetState: ImageBroadcastingWidgetState;
};

export const CommentsPane = observer(function CommentsPanel({ widgetState }: Props) {
  const { t } = useTranslation('imageBroadcast');
  const selectedComment = widgetState.selectedComment;

  if (widgetState.commentsOptions.length === 0) {
    return (
      <div className={styles.CommentsPane}>
        <div className={styles.CommentsEmpty}>{t('commentsEmpty')}</div>
      </div>
    );
  }

  return (
    <div className={styles.CommentsPane}>
      <Select
        className={styles.CommentsSelect}
        options={widgetState.commentsOptions}
        value={selectedComment ? selectedComment.title : undefined}
        onChange={(value) => widgetState.setSelectedComment(value ?? null)}
      />
      {selectedComment && (
        <div className={styles.CommentsScrollWrapper}>
          <Scrollbar style={{ width: '100%', height: '100%' }}>
            <div className={styles.CommentsContent}>
              {selectedComment.syntax === 'MARKDOWN' ? (
                <Markdown
                  options={{
                    forceBlock: true,
                    overrides: markdownComponents,
                    disableParsingRawHTML: true,
                  }}
                >
                  {selectedComment.text}
                </Markdown>
              ) : (
                <div className={styles.CommentsText}>{selectedComment.text}</div>
              )}
            </div>
          </Scrollbar>
        </div>
      )}
    </div>
  );
});
